import classNames from 'classnames'
import { AddToCart } from '../../AddToCard/ui/AddToCart.jsx'
import { AddToPreferences } from '../../AddToPreferences/ui/AddToPreferences.jsx'
import { QuickView } from '../../QuickView/ui/QuickView.jsx'

export function CommonBlock() {
    return (
        <div className={classNames('d-flex')}>
            <QuickView />
            <AddToPreferences />
            <AddToCart />
        </div>
    )
}
